.modal-cookie {
  top: 0;
  display: block;

  .checkbox-inline {
    margin: 2rem 0;
  }

  label {
    width: 100%;
    margin-bottom: 0.5rem;

    @include media-breakpoint-up(md) {
      width: calc(50% - 1rem);
    }
  }

  .actions {
    margin-bottom: 1rem;
    a {
      margin-right: 0.5rem;
      margin-bottom: 1rem;
    }
  }

  .modal-content {
    > :last-child {
      font-size: $font-size-sm;
    }
  }
}
